import VData from './VData'

export { VData }

export default VData
